var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 11.5C13.6892 11.5 15 10.2388 15 8.5C15 6.76121 13.6892 5.5 12.25 5.5C10.8108 5.5 9.5 6.76121 9.5 8.5C9.5 10.2388 10.8108 11.5 12.25 11.5ZM12.25 13C14.5972 13 16.5 10.9853 16.5 8.5C16.5 6.01472 14.5972 4 12.25 4C9.90279 4 8 6.01472 8 8.5C8 10.9853 9.90279 13 12.25 13Z",
    fill: "#3D3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80861 16.609C6.58473 16.8078 6.5 16.9911 6.5 17.25C6.5 17.6112 6.60275 17.7476 6.70118 17.8399C6.85169 17.9809 7.15649 18.1492 7.71965 18.2782C8.73698 18.5112 10.0225 18.5065 11.3919 18.5015C11.593 18.5007 11.7959 18.5 12 18.5C12.2041 18.5 12.407 18.5007 12.6081 18.5015C13.9775 18.5065 15.263 18.5112 16.2804 18.2782C16.8435 18.1492 17.1483 17.9809 17.2988 17.8399C17.3972 17.7476 17.5 17.6112 17.5 17.25C17.5 16.9911 17.4153 16.8078 17.1914 16.609C16.9235 16.371 16.4716 16.1382 15.8271 15.9489C14.5403 15.5708 12.9666 15.5 12 15.5C11.0334 15.5 9.45966 15.5708 8.17286 15.9489C7.52836 16.1382 7.07654 16.371 6.80861 16.609ZM5 17.25C5 14.2759 10 14 12 14C14 14 19 14.2759 19 17.25C19 20.0324 15.4766 20.0156 12.5871 20.0019C12.388 20.0009 12.1918 20 12 20C11.8082 20 11.612 20.0009 11.4129 20.0019C8.52337 20.0156 5 20.0324 5 17.25Z",
    fill: "#AD49CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.9573a9fc8f244132e0db1200ee30a33f.svg";
export { ForwardRef as ReactComponent };